import React from "react";

interface ForeignStaffContactInfoProps {
  formData: {
    notes: string;
  };
  handleInputChange: (field: string, value: string) => void;
}

const ForeignStaffContactInfo: React.FC<ForeignStaffContactInfoProps> = ({
  formData,
  handleInputChange,
}) => {
  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      {/* Notes Section - Full Width */}
      <div className="mb-4">
        {/* Ghi chú */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Ghi chú
          </label>
          <textarea
            value={formData.notes}
            onChange={(e) => handleInputChange("notes", e.target.value)}
            rows={4}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Ghi chú..."
          />
        </div>
      </div>
    </div>
  );
};

export default ForeignStaffContactInfo;
